import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

interface LanguagePopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const LanguagePopup: React.FC<LanguagePopupProps> = ({ isOpen, onClose }) => {
  const { language, setLanguage } = useLanguage();
  
  if (!isOpen) return null;
  
  const handleLanguageSelect = (lang: 'en' | 'he') => {
    setLanguage(lang);
    onClose();
  };
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30" onClick={onClose}>
      <div 
        className="bg-white rounded-lg shadow-xl w-80 max-w-full overflow-hidden" 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-4 border-b">
          <h2 className="text-lg font-semibold">Select Language</h2>
        </div>
        
        <div className="p-4 space-y-2">
          <button 
            className={`w-full p-3 text-left rounded-md hover:bg-gray-100 ${language === 'en' ? 'bg-gray-100 font-medium' : ''}`}
            onClick={() => handleLanguageSelect('en')}
          >
            English
          </button>
          
          <button 
            className={`w-full p-3 text-right rounded-md hover:bg-gray-100 ${language === 'he' ? 'bg-gray-100 font-medium' : ''}`}
            onClick={() => handleLanguageSelect('he')}
          >
            עברית
          </button>
        </div>
        
        <div className="p-4 border-t flex justify-end">
          <button 
            className="px-4 py-2 text-sm text-gray-600 hover:text-gray-900"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguagePopup; 